var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDownloadPopover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13304",
    "data-name": "Rectangle 13304",
    width: 15,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Download_3Dots",
    transform: "translate(7.5 7.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28982",
    "data-name": "Group 28982",
    transform: "translate(-7.5 -7.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48089",
    "data-name": "Path 48089",
    d: "M8.4,0H6.6V7.7L4.2,5.2,2.9,6.5l4.6,4.6,4.6-4.6L10.8,5.2,8.4,7.7Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28981",
    "data-name": "Group 28981",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48090",
    "data-name": "Path 48090",
    d: "M14.1,14.985a.9.9,0,0,0,.9-.9V10.4H13.2v2.791H1.8V10.4H0v3.688a.9.9,0,0,0,.9.9Z",
    transform: "translate(0 -.035)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDownloadPopover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_download_popover.4ba4b654e80b12edec970a949d75c263.svg";